import { PermissionKey } from "@/manager/manager/agent-dashboard-permission-manager";

// 侧边栏白名单：操作日志
export const WHITE_LIST_KEYS: PermissionKey[] = [
  'log'
];